import { Image } from '../Image'

import { SIZE_CLASS_MAP, SIZE_TEMPLATE_MAP } from './constants'
import styles from './styles.module.scss'
import { ListingPictureProps } from './types'

export const ListingPicture = ({
  url,
  alt,
  className,
  size = 'medium',
  showPlaceholder = false,
}: ListingPictureProps) => {
  const sizeClassName = SIZE_CLASS_MAP[size]
  const template = SIZE_TEMPLATE_MAP[size]
  const combinedClassName = [styles.pictureBase, sizeClassName, className]
    .filter(Boolean)
    .join(' ')

  if (!url) {
    if (showPlaceholder) {
      return <div className={combinedClassName} />
    }

    return null
  }

  return (
    <div className={combinedClassName}>
      <Image url={url} alt={alt ?? ''} template={template} />
    </div>
  )
}
